// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zOzuq","projects":"styles_projects__ehUmc"};